import styled from 'styled-components';
import { Grid, Typography, Divider } from '@material-ui/core';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const ScrollableArea = styled.div`
  overflow: ${p => (p.loading ? 'hidden' : 'auto')};
  padding-top: 70px;
  padding-bottom: 100px;
  min-height: 100%;
  width: 100%;
`;

export const Container = styled.div`
  min-height: 100%;

  ${breakpoints.down('xs')} {
    padding-top: 100px;
    padding-bottom: 40px;
  }
`;

export const TitleContainer = styled.div`
  margin-bottom: 35px;
`;

export const Title = styled(Typography)`
  margin-bottom: 15px;
`;

export const DividerStyled = styled(Divider)`
  margin: 50px 0;
`;

export const ContentContainer = styled(Grid)`
  margin-bottom: 35px;
  ${breakpoints.down('xs')} {
    margin-bottom: 0;
  }
`;

export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  min-height: 50px;
`;
